import { getLogger, classifyError } from 'tokyu-hooks'

const withRollbarError =
  (handler?: (error: unknown) => void) => (error: unknown) => {
    const appError = classifyError(error)

    if (appError.kind === 'server' && appError.status === 503) {
      window.location.href = '/maintenance?source=tripla-503'
    }

    if (appError.kind === 'auth') {
      window.location.href = '/'
    }

    getLogger().error('Client error', error)
    handler && handler(error)
  }

export default withRollbarError
